import React, {useEffect} from 'react';
import { LinkOut } from '../components/baseComponents';
import styles from './NoProjects.module.scss';
import idleFox from '../assets/animations/foxIdle.json'
import lottie from "lottie-web";

export const NoProjects = () => {

  useEffect(() => {
    const container = document.querySelector("#no-projects");
    if(container){
      lottie.loadAnimation({
        container,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: idleFox, // the path to the animation json
      });
    }
  }, [])
  return (
    <div className={styles.NoProjects}>
      <p>Seems like there are no projects.
You can create one in the platform dropdown</p>
    <div id="no-projects" style={{width: '50%'}}>
    </div>
    <LinkOut className={styles.Link} link="https://platform.blings.io/" text='Create Project'/>
    </div>
  )
}
